import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-caret",
  "use": "tamr-icon-caret-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-caret\"><path d=\"M16,23a2,2,0,0,1-1.4-.6l-10-10A2,2,0,0,1,7.4,9.6L16,18.2l8.6-8.6a2,2,0,0,1,2.8,2.8l-10,10A2,2,0,0,1,16,23Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol